export const removeEmptyFields = o => {
  const nonEmptyFields = Object.entries(o)
    .map(([key, value]) => [key, typeof value === 'object' && value !== null ? removeEmptyFields(value) : value])
    .filter(([, value]) => !!value)
  return nonEmptyFields.length === 0 ? null : Object.fromEntries(nonEmptyFields)
}
